// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__2yPqU","text":"style_text__2GWIL","des":"style_des__2liq7"};